import { Link } from 'gatsby';
import { useTranslation } from 'react-i18next';
import Alert from '@material-ui/lab/Alert';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import PropTypes from 'prop-types';
import React, { useRef, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import TextField from '@material-ui/core/TextField';

import config from '../../site-config';

const FoundForm = ({
  code: codeFromProps
}) => {
  const recaptchaRef = useRef(null);
  const { apiHostname, apiVersion, recaptchaSiteKey } = config;
  const { i18n, t } = useTranslation();
  const [state, setState] = useState({
    code: codeFromProps,
    loading: false,
    message: '',
    showConfirmation: false,
    value: '',
  });
  const {
    code,
    loading,
    message,
    showConfirmation,
    value,
  } = state;

  const handleChange = (event) => {
    const { name, value: v } = event.target;

    setState((prevState) => ({
      ...prevState,
      [name]: v,
    }));
  };

  const send = () => {
    setState((prevState) => ({
      ...prevState,
      loading: true,
    }));

    const params = new URLSearchParams();
    params.append('findid', code);
    params.append('msg', message);

    if (recaptchaSiteKey && value) {
      params.append('value', value);
    }

    fetch(
      `https://${apiHostname}/${apiVersion}/checkfindid`,
      {
        body: params,
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        method: 'POST',
      },
    )
      .finally(() => {
        if (recaptchaRef && recaptchaRef.current) {
          recaptchaRef.current.reset();
        }

        setState((prevState) => ({
          ...prevState,
          code: '',
          loading: false,
          message: '',
          showConfirmation: true,
        }));
      });
  };

  return (
    <>
      {!codeFromProps && (
        <div className="my-8">
          <p className="subtitle my-4">
            {t('writeToTheOwner')}
          </p>
        </div>
      )}
      {!!codeFromProps && (
        <div className="my-8">
          <p className="subtitle my-4">
            {t('writeMessageToTheOwner')}
          </p>
        </div>
      )}
      <div className="my-4">
        <TextField
          disabled={!!codeFromProps}
          fullWidth
          label={t('code')}
          name="code"
          onChange={handleChange}
          placeholder={t('writeTheCode')}
          value={code}
          variant="outlined"
        />
      </div>
      <div className="my-4">
        <TextField
          fullWidth
          helperText={(
            <span>
              {t('rememberToAdd')}
              {' '}
              {t('ifYouHave')}
              {' '}
              <Link to="/#faq">
                {t('faq')}
              </Link>
            </span>
          )}
          label={t('message')}
          multiline
          name="message"
          onChange={handleChange}
          placeholder={t('writeAMessage')}
          rows={3}
          rowsMax={5}
          value={message}
          variant="outlined"
        />
      </div>
      {recaptchaSiteKey && (
        <div className="my-4">
          <ReCAPTCHA
            hl={i18n.language}
            onChange={(v) => (
              setState((prevState) => ({
                ...prevState,
                value: v,
              }))
            )}
            ref={recaptchaRef}
            sitekey={recaptchaSiteKey}
          />
        </div>
      )}
      {!loading && (
        <div className="my-4">
          <Button
            color="primary"
            disabled={(recaptchaSiteKey && !value) || !code || !message}
            fullWidth
            onClick={send}
            variant="contained"
          >
            {t('send')}
          </Button>
        </div>
      )}
      {loading && (
        <div className="my-4 text-center">
          <CircularProgress />
        </div>
      )}
      {showConfirmation && (
        <div className="my-4">
          <Alert severity="success">
            {t('messageSent')}
          </Alert>
        </div>
      )}
    </>
  );
};

FoundForm.propsTypes = {
  code: PropTypes.string,
};

FoundForm.defaultProps = {
  code: '',
};

export default FoundForm;
